import { createAction } from "redux-actions";

export const SESSION_CLEAR = "SESSION_CLEAR";

export default createAction<void>(SESSION_CLEAR);
